import { render, staticRenderFns } from "./popupVideo.vue?vue&type=template&id=4867ff0c&scoped=true"
import script from "./popupVideo.vue?vue&type=script&lang=js"
export * from "./popupVideo.vue?vue&type=script&lang=js"
import style0 from "./popupVideo.vue?vue&type=style&index=0&id=4867ff0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4867ff0c",
  null
  
)

export default component.exports